import moment from "moment";
import { Timeline, TimelineEvent } from "react-event-timeline";
import { statusToTitle, statusToIcon } from "../helpers";

const View = (props) => {
  if (!props.history?.length) {
    return <div className="pl-2 text-gray-800">Belum Ada Riwayat</div>;
  }

  return (
    <Timeline lineColor={props.textColor}>
      {props.history.map((i, idx) => {
        const StatusIcon = statusToIcon(i.status);
        return (
          <TimelineEvent
            key={idx}
            className="mb-3 text-sm"
            title={
              <div className="flex space-x-3 ml-2">
                <div className="whitespace-nowrap">
                  <div className="text-gray-900 font-semibold">
                    {moment(i.updatedAt).format("D MMM")}
                  </div>
                  <div className="text-gray-800">{moment(i.updatedAt).format("HH:mm")}</div>
                </div>
                <div>
                  <div className="text-gray-900 font-semibold">{statusToTitle(i.status)}</div>
                  <div className="text-gray-800">{i.note}</div>
                </div>
              </div>
            }
            bubbleStyle={{
              color: props.textColor,
              backgroundColor: props.textColor,
              borderColor: props.textColor,
              width: "40px",
              height: "40px",
              left: "-4px",
            }}
            iconStyle={{ color: "#FFFFFF", left: "2px" }}
            icon={<StatusIcon className="w-5" style={{ color: "#FFFFFF" }} />}
          />
        );
      })}
    </Timeline>
  );
};

export default View;
